/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

export const headerProps = (props: any, { column }: any): any =>
  getStyles(props, column.align);

export const cellProps = (props: any, { cell }: any): any =>
  getStyles(props, cell.column.align);

export const getStyles = (props: any, align = "left"): any => [
  props,
  {
    style: {
      justifyContent: align === "right" ? "flex-end" : "flex-start",
      alignItems: "flex-start",
      display: "flex",
    },
  },
];

export const getConfigColumnStyle = (): React.CSSProperties => {
  return {
    boxSizing: "border-box",
    flex: "40 0 auto",
    width: 40,
    maxWidth: 40,
    minWidth: 40,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    display: "flex",
  };
};

export const isProcessData = (columnKey: any): boolean => {
  return columnKey?.startsWith("process_state_");
};
